"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionNotification = void 0;
var React = require("react");
var types_1 = require("./types");
var SectionNotificationButton_1 = require("./Button/SectionNotificationButton");
var SectionNotificationText_1 = require("./Text/SectionNotificationText");
var SectionNotificationIcon_1 = require("./Icon/SectionNotificationIcon");
var SectionNotification_st_css_1 = require("./SectionNotification.st.css");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var SectionNotificationContext_1 = require("./SectionNotificationContext");
/** Section notification displays an important, succinct message, and provides actions for users to address and can not be dismissed.  */
var SectionNotification = /** @class */ (function (_super) {
    __extends(SectionNotification, _super);
    function SectionNotification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SectionNotification.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, type = _a.type, className = _a.className, size = _a.size;
        var isError = type === types_1.SectionNotificationType.error;
        var isAlert = type === types_1.SectionNotificationType.alert;
        var isWired = type === types_1.SectionNotificationType.wired;
        var isSuccess = type === types_1.SectionNotificationType.success;
        var contents = [];
        var buttons = [];
        React.Children.forEach(children, function (child) {
            if (child && child.type === SectionNotificationButton_1.SectionNotificationButton) {
                buttons.push(child);
            }
            else {
                contents.push(child);
            }
        });
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var rtl = _a.rtl;
            return (React.createElement("div", { className: SectionNotification_st_css_1.st(SectionNotification_st_css_1.classes.root, {
                    error: isError,
                    alert: isAlert,
                    rtl: rtl,
                    size: size,
                    wired: isWired,
                    success: isSuccess,
                }, className), role: "alert", "data-error": isError, "data-alert": isAlert, "data-wired": isWired, "data-success": isSuccess, "aria-live": "assertive", "data-hook": _this.props['data-hook'] },
                React.createElement("div", { className: SectionNotification_st_css_1.classes.main },
                    React.createElement("div", { className: SectionNotification_st_css_1.classes.contentsWrapper }, contents),
                    buttons ? (React.createElement(SectionNotificationContext_1.SectionNotificationProvider, { value: { type: type } },
                        React.createElement("div", { className: SectionNotification_st_css_1.classes.buttonsWrapper }, buttons))) : null)));
        }));
    };
    SectionNotification.displayName = 'SectionNotification';
    SectionNotification.defaultProps = {
        type: types_1.SectionNotificationType.default,
        size: types_1.SectionNotificationSize.regular,
    };
    SectionNotification.Text = SectionNotificationText_1.SectionNotificationText;
    SectionNotification.Icon = SectionNotificationIcon_1.SectionNotificationIcon;
    SectionNotification.Button = SectionNotificationButton_1.SectionNotificationButton;
    return SectionNotification;
}(React.Component));
exports.SectionNotification = SectionNotification;
//# sourceMappingURL=SectionNotification.js.map